import { jsxs as r, jsx as e } from "react/jsx-runtime";
function o(t) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "33", viewBox: "0 0 149 33", width: "149", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    /* @__PURE__ */ e("g", { filter: "url(#filter0_dd_2812_101275)", children: /* @__PURE__ */ e(
      "path",
      {
        d: "M134.083 24.4434L134.083 7.07084L144.875 7.07084L141.637 15.7571L144.875 24.4434L134.083 24.4434Z",
        fill: "#2968FF"
      }
    ) }),
    /* @__PURE__ */ e("g", { filter: "url(#filter1_dd_2812_101275)", children: /* @__PURE__ */ e(
      "path",
      {
        d: "M14.292 7.07031L14.292 24.4428L3.50001 24.4428L6.7376 15.7566L3.50001 7.07031L14.292 7.07031Z",
        fill: "#2968FF"
      }
    ) }),
    /* @__PURE__ */ e("g", { filter: "url(#filter2_dd_2812_101275)", children: /* @__PURE__ */ e("rect", { fill: "#2968FF", height: "25.8762", rx: "4", width: "120.87", x: "13.752", y: "2.93359" }) }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M27.9507 10.4055H22.2547V21.6055H24.5587V17.1255H25.7747L27.3907 21.6055H29.7267L27.9987 16.9655L29.6787 15.2695V12.1495L27.9507 10.4055ZM26.9107 12.7095L27.3907 13.1895V14.6775L26.9107 15.1575H24.5587V12.7095H26.9107ZM38.8575 10.4055H31.8015V21.6055H38.8735V19.3175H34.1055V16.7575H37.4015V14.9815H34.1055V12.7095H38.8575V10.4055ZM46.4187 10.4055H42.6107L40.6107 12.4055V19.5255C41.2987 20.2295 42.0027 20.9175 42.6907 21.6055H46.3387L48.1467 19.7975V17.1575H45.8587V18.8055C45.6827 18.9815 45.5067 19.1415 45.3467 19.3175H43.5227L42.9147 18.6935V13.3015L43.4907 12.7095H45.3787L45.8587 13.1895V14.6295H48.1467V12.1495L46.4187 10.4055ZM57.7125 12.2775L55.8405 10.4055H51.9045L50.0325 12.2775V19.6695L51.9845 21.6055H55.7445L57.7125 19.6695V12.2775ZM55.4085 13.2375V18.7415L54.8485 19.3175H52.8965L52.3365 18.7415V13.2375L52.8645 12.7095H54.8645L55.4085 13.2375ZM68.843 10.4055H66.267L64.395 14.1815L62.539 10.4055H59.739V21.6055H61.915V13.5095L63.819 17.2055H64.747L66.651 13.5095V21.6055H68.843V10.4055ZM80.1087 10.4055H77.5327L75.6607 14.1815L73.8047 10.4055H71.0047V21.6055H73.1807V13.5095L75.0847 17.2055H76.0127L77.9167 13.5095V21.6055H80.1087V10.4055ZM89.3263 10.4055H82.2703V21.6055H89.3423V19.3175H84.5743V16.7575H87.8703V14.9815H84.5743V12.7095H89.3263V10.4055ZM99.0474 10.4055H97.0794V17.2375L93.8314 10.4055H91.2234V21.6055H93.1914V14.2935L96.8074 21.6055H99.0474V10.4055ZM108.791 12.6775L106.519 10.4055H101.223V21.6055H106.439L108.791 19.2535V12.6775ZM105.687 12.7095L106.487 13.5095V18.4855L105.655 19.3175H103.527V12.7095H105.687ZM117.873 10.4055H110.817V21.6055H117.889V19.3175H113.121V16.7575H116.417V14.9815H113.121V12.7095H117.873V10.4055ZM127.338 12.6775L125.066 10.4055H119.77V21.6055H124.986L127.338 19.2535V12.6775ZM124.234 12.7095L125.034 13.5095V18.4855L124.202 19.3175H122.074V12.7095H124.234Z",
        fill: "#F6F7F7"
      }
    ),
    /* @__PURE__ */ r("defs", { children: [
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "23.373",
          id: "filter0_dd_2812_101275",
          width: "16.792",
          x: "131.083",
          y: "5.07031",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_2812_101275" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_2812_101275" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_2812_101275", mode: "normal", result: "effect2_dropShadow_2812_101275" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_2812_101275", mode: "normal", result: "shape" })
          ]
        }
      ),
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "23.373",
          id: "filter1_dd_2812_101275",
          width: "16.792",
          x: "0.5",
          y: "5.07031",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_2812_101275" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_2812_101275" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_2812_101275", mode: "normal", result: "effect2_dropShadow_2812_101275" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_2812_101275", mode: "normal", result: "shape" })
          ]
        }
      ),
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "31.877",
          id: "filter2_dd_2812_101275",
          width: "126.87",
          x: "10.752",
          y: "0.933594",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_2812_101275" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_2812_101275" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_2812_101275", mode: "normal", result: "effect2_dropShadow_2812_101275" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_2812_101275", mode: "normal", result: "shape" })
          ]
        }
      )
    ] })
  ] });
}
export {
  o as default
};
